import { appRoutes } from "../constants";
import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
import { LocationSource } from "./LocationSource";
import { SanitizePlanLegacyAdditionalFields } from "../utils/SanitizePlanAdditionalFields";

export class QLoadPlanRFC extends QRFC {
  constructor() {
    super();
  }

  InitLoadPlanRFC(callbackObj) {
    this.fWSMgr = callbackObj;
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, userName, mode, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    if (this.fWSMgr && this.fWSMgr.fWaiting) {
      this.fWSMgr.ClearAppLoadingAnimation();
      this.fWSMgr.fWaiting = null;
    }
    if (r["success"]) {
      if (!callBackObj.fLoadPlanPreventClose) {
        this.fWSMgr.CloseDocument();
      } else {
        callBackObj.fLoadPlanPreventClose = false;
      }
      const newDoc = this.fWSMgr.InitializeDoc({}, false, true);
      var eventTracker = this.fWSMgr.GetUsageTracker();
      eventTracker.ReportEvent("planning.plan.opened");
      // Only navigate if not already on a plan resource route — don't stomp /plan/123
      if (!LocationSource.getPathname().includes("/plan/") && this.fWSMgr.routerNavigate) {
        this.fWSMgr.routerNavigate(appRoutes.planning);
      }
      this.fWSMgr.SignalDocChanged();
      let combinedChartMeta = { ...r["chartMeta"], ...r["info"] };
      combinedChartMeta["planMetrics"] = r["planMeta"]["metrics"];
      combinedChartMeta["planMeta"] = r["planMeta"];
      // Temporarily handle legacy plans(that are not versioned as v1) that may have additional fields data in the DB.
      // This would only be holder additional fields data, so convert it to the appropriate format which supports multiple object types.
      combinedChartMeta.planMeta.fields = Array.isArray(r.planMeta.fields)
        ? SanitizePlanLegacyAdditionalFields(r.planMeta)
        : r.planMeta.fields;
      newDoc.ChartMetadataResult(true, combinedChartMeta, r);
    } else {
      Globals._svrChartMgr.SetLastPlanID(null);
      callBackObj.HandleFailedSvrQuery(r);
      // Recovery: backend rejected the plan load (access denied,
      // not found, etc.). Code 5005 carries an explicit
      // permittedChartID from the server — honor it directly.
      // Other failures route through the centralized
      // FallbackToSafeChart helper.
      if (r["code"] === 5005 && r["permittedChartID"] != null) {
        Globals._accountInfo.fLaunchChartID = r["permittedChartID"];
        this.fWSMgr.SwitchToMasterChart(r["permittedChartID"]);
      } else {
        this.fWSMgr.FallbackToSafeChart();
      }
    }
    callBackObj.PrepRenderWS();
    callBackObj.RenderWS();
  }
}
